import { TIN_FORMAT_REGEX, VALIDATE_NAME_REGEX, VALIDATE_ZIP_CODE_REGEX } from "../../../../libs/utility/constants";
import { PAGE_STATE, RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT } from "../../constants/constants";
import { CHOOSE_METHOD_CARD_NAMES } from "../addpayernew/createone/getmethod/constants/constants";

export const ADD_RECIPIENT_INITIAL_STATE = {
    payersList: [],
    loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

    methodType: CHOOSE_METHOD_CARD_NAMES.CREATE_ONE,
    RequestType: "",
    RecipientType: null,

    submittedRecipient: {},

    recipientBasicInfo: {
        allRequiredFieldsTouched: false,
        tinNotProvided: false,

        RecipientFirstName: {
            value: "",
            errors: {},
            rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid recipient name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } }
        },

        RecipientMiddleName: { value: "", errors: {}, rules: { required: true, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid recipient name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } } },

        RecipientLastName: { value: "", errors: {}, rules: { required: true, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid recipient name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } } },

        RecipientTIN: { value: "", errors: {}, rules: { required: true, regex: { pattern: TIN_FORMAT_REGEX, message: "Please enter valid TIN" } } },

        RecipientEmail: {
            value: "",
            errors: {},
            rules: { required: false, regex: { pattern: /^\S+@\S+\.\S+$/, message: "Please enter a valid email address" } }
        },

        RecipientPhNo: {
            value: "",
            errors: {},
            rules: { required: false, minLength: 8, maxLength: 15 }
        },

        RFilerType: { value: "", errors: {} },
        RecipientSuffix: { value: "", errors: {} },
    },

    recipientAddressInformation: {
        allRequiredFieldsTouched: false,

        RecipientAddress: {
            value: "",
            errors: {},
            rules: { required: true, maxLength: 48, regex: { pattern: /^(?=.*[A-Za-z0-9])[A-Za-z0-9 .\-,#/]*$/, message: "Please enter a valid address with at least one letter. Special characters alone are not allowed." } }
        },
        RecipientAddress2: { value: "" },
        RecipientCountry: {
            label: "",
            value: "",
            errors: {},
            rules: { required: true }
        },
        RecipientState: {
            label: "",
            value: "",
            errors: {},
            rules: { required: true }
        },
        RecipientCity: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: /^[a-zA-Z ]+$/, message: "Please enter a valid city name. The name should not contain any numbers" } }
        },
        RecipientZIP: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: VALIDATE_ZIP_CODE_REGEX, message: "Please enter a valid ZIP Code. The ZIP Code should only contain numbers" } }
        },
    },

    recipientOptionalInformation: {
        allRequiredFieldsTouched: false,

        AttentionTo: {
            value: "",
            errors: {},
        },

        Isrecipientclient: {
            value: "",
            errors: {},
            rules: { maxLength: 40, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT }}
        }
    },

    zipCodeValidationSuccess: false,
    recipientCreationSuccessful: false,
    recipientEditedSuccessful: false,

    selectedPayer: {},
    selectedRecipient: {},

    RecipentDetailId: "",
    W8W9Fees: 0,
}

export const RECIPIENT_SSN_TOOLTIP = { id: "ssn-tooltip", label: "Social Security Number (SSN)", tooltipText: "The SSN identifies U.S. citizens and is used to determine benefits & track income." };

export const RECIPIENT_EIN_TOOLTIP = { id: "ein-tooltip", label: "Employer Identification Number (EIN)", tooltipText: "An EIN identifies businesses in the US" };

export const RECIPIENT_PHONE_NUM_FIELD_NAME = "RecipientPhNo"
export const PAYER_BUSINESS_FIELD_NAME= "PayerLastName"

export const ADD_RECIPIENT_LOADING_STATES = {
    VALIDATE_ZIP_CODE_LOADING: "VALIDATE_ZIP_CODE_LOADING",
    VALIDATE_ZIP_CODE_READY: "VALIDATE_ZIP_CODE_READY",
    SAVE_RECIPIENT_LOADING: "SAVE_RECIPIENT_LOADING",
    SAVE_RECIPIENT_READY: "SAVE_RECIPIENT_READY",
    EDIT_RECIPIENT_LOADING: "EDIT_RECIPIENT_LOADING",
    EDIT_RECIPIENT_READY: "EDIT_RECIPIENT_READY",
    GET_TEMPLATE_LOADING: "GET_TEMPLATE_LOADING",
    GET_TEMPLATE_READY:"GET_TEMPLATE_READY",
    BULK_UPLOAD_SHEET_LOADING: "BULK_UPLOAD_SHEET_LOADING",
    BULK_UPLOAD_SHEET_READY: "BULK_UPLOAD_SHEET_READY",
    VALIDATE_BULK_UPLOAD_SHEET_RECORD_LOADING: "VALIDATE_BULK_UPLOAD_SHEET_RECORD_LOADING",
    VALIDATE_BULK_UPLOAD_SHEET_RECORD_READY: "VALIDATE_BULK_UPLOAD_SHEET_RECORD_READY",
}

export const ADD_RECIPIENT_MESSAGE_MAP ={
    [ADD_RECIPIENT_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING] : "Validating Zipcode",
    [ADD_RECIPIENT_LOADING_STATES.SAVE_RECIPIENT_LOADING] : "Adding Recipient",
    [ADD_RECIPIENT_LOADING_STATES.EDIT_RECIPIENT_LOADING] : "Updating Recipient Details",
    [ADD_RECIPIENT_LOADING_STATES.BULK_UPLOAD_SHEET_LOADING]: "Uploading file...",
    [ADD_RECIPIENT_LOADING_STATES.VALIDATE_BULK_UPLOAD_SHEET_RECORD_LOADING]: "Validating Records...",
    [ADD_RECIPIENT_LOADING_STATES.GET_TEMPLATE_LOADING]: "Downloading Template...",
}